import { produce } from "immer";
import * as Actions from "./rulesActions";
import updateArray from "immutability-helper";

const initialState = {
  isLoading: false,
  inErrorMessage: null,
  outErrorMessage: null,
  inRules: {},
  outRules: {}
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.IN_FETCHING: {
      draft.isLoading = true;
      break;
    }

    case Actions.OUT_FETCHING: {
      draft.isLoading = true;
      break;
    }

    case Actions.SET_IN_ERROR_MESSAGE: {
      draft.isLoading = false;
      draft.inErrorMessage = action.payload;
      break;
    }

    case Actions.SET_OUT_ERROR_MESSAGE: {
      draft.isLoading = false;
      draft.outErrorMessage = action.payload;
      break;
    }

    case Actions.FETCH_IN_SUCCESS: {
      draft.isLoading = false;
      draft.inErrorMessage = null;
      draft.inRules = action.payload;

      break;
    }

    case Actions.FETCH_OUT_SUCCESS: {
      draft.isLoading = false;
      draft.outErrorMessage = null;
      draft.outRules = action.payload;

      break;
    }

    case Actions.CHANGE_STATUS: {
      draft.isLoading = true;

      draft[`${action.payload.direction}Rules`].rules[
        action.payload.index
      ].active = action.payload.status;

      break;
    }

    case Actions.UPDATE: {
      draft.isLoading = true;

      draft[`${action.payload.direction}Rules`].rules[action.payload.index] =
        action.payload.data;

      break;
    }

    case Actions.ADD: {
      draft.isLoading = true;

      draft[`${action.payload.direction}Rules`].rules.push(action.payload.data);

      break;
    }

    case Actions.MOVE: {
      draft.isLoading = true;

      const { direction, dragIndex, hoverIndex } = action.payload;
      const dragRecord = draft[`${direction}Rules`].rules[dragIndex];

      draft[`${direction}Rules`].rules = updateArray(
        draft[`${direction}Rules`].rules,
        {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRecord]
          ]
        }
      );

      break;
    }

    case Actions.REMOVE: {
      draft.isLoading = true;

      draft[`${action.payload.direction}Rules`].rules.splice(
        action.payload.index,
        1
      );

      break;
    }

    case Actions.RESET: {
      return {
        ...initialState
      };
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
